import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MaterialModule } from '@shared/bundles/material/material.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReactiveFormsModule } from '@angular/forms';

import { FiltersComponent } from './filters.component';
import { FiltersGroupComponent } from './group/filters-group.component';
import { FiltersOperatorComponent } from './operator/filters-operator.component';
import { FiltersRuleComponent } from './rule/filters-rule.component';
import { ToolbarModule } from '@shared/components/layout/toolbar/toolbar.module';

@NgModule({
    declarations: [
        FiltersComponent,
        FiltersGroupComponent,
        FiltersRuleComponent,
        FiltersOperatorComponent
    ],
    exports: [
        FiltersComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MaterialModule,
        MatAutocompleteModule,
        MatDividerModule,
        MatToolbarModule,
        MatChipsModule,
        MatIconModule,
        MatSelectModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        ToolbarModule,
        TranslateModule
    ],
    providers: [
        {
            provide: 'accountsService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('accounts');
            }
        },
        {
            provide: 'sfWalkthrough',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('sfWalkthrough');
            }
        },
        {
            provide: 'contactsService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('contactsService');
            }
        },
        {
            provide: 'modelService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('model');
            }
        },
        {
            provide: 'stateService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('$state');
            }
        },
        {
            provide: 'sfDiscardDialog',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('sfDiscardDialog');
            }
        },
        {
            provide: 'tagsService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('tagsService');
            }
        },
        {
            provide: 'savedFilterService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('savedFilterService');
            }
        },
        {
            provide: 'savedFiltersService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('savedFiltersService');
            }
        },
        {
            provide: 'customFieldsService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('customfields');
            }
        },
        {
            provide: 'usersService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('users');
            }
        },
        {
            provide: 'filterService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('filterService');
            }
        },
        {
            provide: 'leadsService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('leads');
            }
        },
        {
            provide: 'utilsService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('utils');
            }
        },
        {
            provide: 'pipelinesService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('pipelines');
            }
        },
        {
            provide: 'workflowService',
            deps: ['$injector'],
            useFactory: ($injector: any) => {

                return $injector.get('workflowService');
            }
        }
    ]
})
export class FiltersModule {}
